export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14270.3ffbc640.jpg";